import classes from './divider.module.scss';
export const Divider = () => <div className={classes.root} />;
